import { useSetAtom } from "jotai";
import React, { useEffect } from "react";

import { PlatformSpecificErrorBoundary } from "../../features/ErrorHandling/components/PlatformSpecificErrorBoundary";
import { hasSessionBeenChecked_atom } from "./sessionCheckerAtoms";

/**
 *
 * This is here so that an unauthenticated user will still flip the "hasSessionBeenChecked" atom.
 */
export const SessionCheckerErrorBoundary = ({
  children,
}: {
  children: React.JSX.Element;
}) => {
  return (
    <PlatformSpecificErrorBoundary
      fallback={({ error, resetError }: any) => (
        <ErrorFallback error={error} resetError={resetError} />
      )}
    >
      {children}
    </PlatformSpecificErrorBoundary>
  );
};

function ErrorFallback({ error, resetError }: { error: any; resetError: any }) {
  const setHasSessionBeenChecked = useSetAtom(hasSessionBeenChecked_atom);
  useEffect(() => {
    setHasSessionBeenChecked(true);
  });

  return null;
}
